import '~/lms/styles/lms-tokens.scss'
import '~/lms/styles/lms-rails-chrome.scss'
import '~/lms/styles/lms-rails-skin.scss'
import '@/shared/utils/disableNumberInputWheel'
import { installLmsNotice } from '~/lms/noticeHost'

document.body.classList.add('lms-modern-ui')
installLmsNotice()
